import { render, staticRenderFns } from "./AllShipmentTable.vue?vue&type=template&id=1edffae6&scoped=true"
import script from "./AllShipmentTable.vue?vue&type=script&lang=js"
export * from "./AllShipmentTable.vue?vue&type=script&lang=js"
import style0 from "./AllShipmentTable.vue?vue&type=style&index=0&id=1edffae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edffae6",
  null
  
)

export default component.exports